import React from 'react';
import Title from '../shared/Title';
import Connection from '../../assets/imgs/ourcorevalues/connection.png';
import Honesty from '../../assets/imgs/ourcorevalues/honesty.png';
import Aspiration from '../../assets/imgs/ourcorevalues/aspiration.png';
import Efficiency from '../../assets/imgs/ourcorevalues/efficiency.png';
import Inspiration from '../../assets/imgs/ourcorevalues/inspiration.png';
import Productivity from '../../assets/imgs/ourcorevalues/productivity.png';
import Commitment from '../../assets/imgs/ourcorevalues/commitment.png';
import Excellence from '../../assets/imgs/ourcorevalues/excellence.png';

const OurCoreValues = () => {
    return (
        <>
            <div className="3xl:max-w-[1500px] 3xl:inline-block xl:px-52 md:px-20 px-10 py-10 text-xl text-center">
                <Title text1="Values" text2="That Define Us" colorForText={2} />
                <p className="text-grey-700">
                    Our essence is based on solid values and principles that guide every decision and action. These values allow us to build relationships of trust, drive excellence, and generate a positive impact in everything we do. By consistently applying these core values, we ensure that our commitment to excellence remains at the heart of our culture and strategy.
                </p>

                <div className="grid md:grid-cols-2 gap-9 md:my-16 my-5">
                    <div className="md:flex items-start md:text-left text-center">
                        <img src={Connection} alt="icon" className="mr-5 inline-block" />
                        <div>
                            <h3 className="font-bold text-xl text-blue-800">Connection</h3>
                            <p>
                                We believe in the importance of building authentic and strong relationships. Our ability to connect with people and teams drives understanding, collaboration, and the achievement of shared goals.
                                This value of <strong>Connection</strong> is essential to how we work and grow together.
                            </p>

                        </div>
                    </div>
                    <div className="md:flex items-start md:text-left text-center">
                        <img src={Honesty} alt="icon" className="mr-5 inline-block" />
                        <div>
                            <h3 className="font-bold text-xl text-blue-800">Honesty</h3>
                            <p className="text-grey-700">
                                Honesty is the foundation of our actions and one of our core values. We operate with transparency and ethics in all our interactions, fostering trust and ensuring integrity in every decision we make.
                                By making honesty a pillar of our culture, we build strong, lasting relationships with our clients, collaborators, and partners.
                            </p>
                        </div>
                    </div>
                    <div className="md:flex items-start md:text-left text-center">
                        <img src={Aspiration} alt="icon" className="mr-5 inline-block" />
                        <div>
                            <h3 className="font-bold text-xl text-blue-800">Aspiration</h3>
                            <p className="text-grey-700">
                                Aspiration is what drives us to pursue a bold vision and a constant desire for improvement. We aspire to reach our full potential and create a positive impact that transcends boundaries.
                                This aspiration fuels our innovation and commitment to always aim higher in everything we do.
                            </p>
                        </div>
                    </div>

                    <div className="md:flex items-start md:text-left text-center">
                        <img src={Efficiency} alt="icon" className="mr-5 inline-block" />
                        <div>
                            <h3 className="font-bold text-xl text-blue-800">Efficiency</h3>
                            <p className="text-grey-700">
                                We value the intelligent use of resources, time, and effort. Efficiency not only maximizes our results but also reflects our commitment to sustainability and operational excellence.
                            </p>
                        </div>
                    </div>
                    <div className="md:flex items-start md:text-left text-center">
                        <img src={Inspiration} alt="icon" className="mr-5 inline-block" />
                        <div>
                            <h3 className="font-bold text-xl text-blue-800">Inspiration</h3>
                            <p className="text-grey-700">
                                Efficiency is one of our core values. We value the intelligent use of resources, time, and effort to achieve our goals effectively.
                                This focus on efficiency not only maximizes our results but also reflects our commitment to sustainability, productivity, and operational excellence across all areas of our work.
                            </p>
                        </div>
                    </div>

                    <div className="md:flex items-start md:text-left text-center">
                        <img src={Productivity} alt="icon" className="mr-5 inline-block" />
                        <div>
                            <h3 className="font-bold text-xl text-blue-800">Productivity</h3>
                            <p className="text-grey-700">
                                Productivity is a core value that drives everything we do. At the heart of our success lies a deep commitment to productivity, allowing us to work with focus, discipline, and a clear sense of purpose.
                                By prioritizing productivity in our processes and mindset, we consistently transform innovative ideas into tangible results that generate impact and value.
                            </p>
                        </div>
                    </div>
                    <div className="md:flex items-start md:text-left text-center">
                        <img src={Excellence} alt="icon" className="mr-5 inline-block" />
                        <div>
                            <h3 className="font-bold text-xl text-blue-800">Excellence</h3>
                            <p className="text-grey-700">
                                Excellence is not just a goal; it is our standard. We aim to exceed expectations and set benchmarks in every project, product, or initiative we undertake.
                            </p>
                        </div>
                    </div>

                    <div className="md:flex items-start md:text-left text-center">
                        <img src={Commitment} alt="icon" className="mr-5 inline-block" />
                        <div>
                            <h3 className="font-bold text-xl text-blue-800">Commitment</h3>
                            <p className="text-grey-700">
                                Commitment is at the heart of our culture and one of our core values. We are deeply committed to our promises, our mission, and our values.
                                This commitment drives our daily dedication to achieving objectives, delivering consistent results, and building lasting trust with all our stakeholders.
                                By honoring our commitments, we foster reliability, strengthen relationships, and ensure long-term success for our clients, team, and community.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OurCoreValues;
